import { render, staticRenderFns } from "./ModalSolicitacaoNovaAnalise.vue?vue&type=template&id=c826ce10&scoped=true&lang=pug"
import script from "./ModalSolicitacaoNovaAnalise.vue?vue&type=script&lang=js"
export * from "./ModalSolicitacaoNovaAnalise.vue?vue&type=script&lang=js"
import style0 from "./ModalSolicitacaoNovaAnalise.vue?vue&type=style&index=0&id=c826ce10&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c826ce10",
  null
  
)

export default component.exports